import { render } from "./KidsView.vue?vue&type=template&id=7a5160de"
import script from "./KidsView.vue?vue&type=script&lang=js"
export * from "./KidsView.vue?vue&type=script&lang=js"

import "./KidsView.vue?vue&type=style&index=0&id=7a5160de&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__